import { getParsedDateAsISO, normalizeBirthDateInput } from '@lili/utils/formatting';
import { normalizeSsnInput } from '@lili/utils/validation';
import { HttpService } from '@Services/index';
import { useBoundStore } from '@Store/index.ts';
import { OnboardingFormFields } from '@Types/index.ts';
import { OnboardingFlowIdentifier } from '@Types/onboarding.types';
import { IdentityFormTypes } from '@Components/Identity/IdentityFormTypeSwitcher';
import type { IIdentityForm, IIdentityUsForm } from '@Lib/Identity/types';

const _generateUsBody = (props: IIdentityUsForm) => {
  return {
    birthDate: normalizeBirthDateInput(
      getParsedDateAsISO(props[OnboardingFormFields.DATE_OF_BIRTH])
    ),
    ssn: normalizeSsnInput(props[OnboardingFormFields.SSN]),
  };
};

const _generateNonUsBody = (props: IIdentityForm, dateFormat?: string) => {
  return {
    birthDate: normalizeBirthDateInput(
      getParsedDateAsISO(props[OnboardingFormFields.DATE_OF_BIRTH], dateFormat)
    ),
    idGovNumber: props[OnboardingFormFields.NATIONAL_ID_NUMBER],
    idType: 'passport', // Hard coded value
    idNumber: props[OnboardingFormFields.PASSPORT_NUMBER],
    idCountry: props[OnboardingFormFields.NATIONALITY],
  };
};

interface IUpdateCustomerIdentity {
  props: IIdentityUsForm | IIdentityForm;
  formType: IdentityFormTypes;
  dateFormat?: string;
}

export const updateCustomerIdentity = async ({
  props,
  formType,
  dateFormat,
}: IUpdateCustomerIdentity) => {
  const isEmbedded = useBoundStore.getState().onboardingSlice.getIsEmbedded();
  const { customerId } = useBoundStore.getState().customer;
  const {
    onboardingFlowIdentifier,
    authorizedUserId,
    customerId: authUserCustomerId,
  } = useBoundStore.getState().onboardingSlice.getOnboardingData();

  let url: string;
  if (onboardingFlowIdentifier === OnboardingFlowIdentifier.AUTHORIZED_USER) {
    url = `v4/onboarding/user/${authUserCustomerId}/authorized/user/${authorizedUserId}/identity`;
  } else if (isEmbedded) {
    url = `v4/secureonboarding/partner/user/${customerId}/kyc`;
  } else {
    url = `v4/secureonboarding/user/${customerId}/kyc`;
  }

  const body =
    formType === IdentityFormTypes.us
      ? _generateUsBody(props as IIdentityUsForm)
      : _generateNonUsBody(props as IIdentityForm, dateFormat);

  try {
    const { data } = await HttpService.post(url, { ...body });
    return data;
  } catch (error) {
    throw error;
  }
};
